// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4378c3d4","186":"1e11cd6a","225":"bb258c0f","344":"8a7ccab0","372":"cd096a3d","377":"2892ed80","738":"2458a935","841":"0fdaad34","856":"db78202b"}[chunkId] + ".chunk.js";
};